module.exports = __webpack_public_path__ + "static/Fabriga-da1bbcc4da2a550821eea3ba4047550d.woff";